import * as React from 'react';

const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path fill="currentColor" d="m15.705 7.705-4.58 4.59 4.58 4.59-1.41 1.41-6-6 6-6z" />
    </svg>
);
export default ArrowLeft;
